{
    "ServerStatus_heading_applicationProperties": "Proprietà dell'applicazione",
    "ServerStatus_action_refresh": "Aggiorna stato",
    "NAME": "ServerStatusLanguage"
}